export default __webpack_public_path__ + "static/media/lesson-pic2.87b4349b.jpg";